/**
 * @desc warehouseCostApprovalPushToEbs
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(body: defs.fulfilment.WarehouseCostPushEbsRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/test/warehouseCostApprovalPushToEbs`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
